import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

export interface QuestionAssignmentDto {
  id: number;
  questionId: number;
  eventId: number;
  round: number;
}

export interface QuestionAssignmentCreateDto {
  questionId: number;
  eventId: number;
  round: number;
}

export interface QuestionAssignmentUpdateDto {
  questionId: number;
  eventId: number;
  round: number;
}

@Injectable({
  providedIn: 'root'
})
export class QuestionAssignmentService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = '/api/questionassignments';

  getAll(): Observable<QuestionAssignmentDto[]> {
    return this.http.get<QuestionAssignmentDto[]>(this.apiUrl);
  }

  create(data: QuestionAssignmentCreateDto): Observable<QuestionAssignmentDto> {
    return this.http.post<QuestionAssignmentDto>(this.apiUrl, data);
  }

  update(id: number, data: QuestionAssignmentUpdateDto): Observable<QuestionAssignmentDto> {
    return this.http.put<QuestionAssignmentDto>(`${this.apiUrl}/${id}`, data);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }
}